onReady(($) => {
    $('.logo-scroller')
        .each((index, module) => {
            $('.images', module)
                .slick({
                    slidesToShow: 6,
                    autoplay: true,
                    prevArrow: false,
                    nextArrow: false,
                    autoplaySpeed: 2500,
                    speed: 1000,
                    swipeToSlide: true,
                    responsive: [
                        {
                            breakpoint: 980,
                            settings: {
                                slidesToShow: 3,
                            },
                        },
                    ],
                });
        });
    $('.image-gallery')
        .each((index, module) => {
            $('.images', module)
                .slick({
                    dots: false,
                    fade: false,
                    arrows: true,
                    autoplay: true,
                    infinite: true,
                    slidesToShow: 9,
                    slidesToScroll: 3,
                    nextArrow: module.querySelector('.slick-next'),
                    prevArrow: module.querySelector('.slick-prev'),
                    responsive: [
                        {
                            breakpoint: 2360,
                            settings: {
                                slidesToShow: 6,
                            },
                        },
                        {
                            breakpoint: 1180,
                            settings: {
                                slidesToShow: 5,
                            },
                        },
                        {
                            breakpoint: 857,
                            settings: {
                                dragging: true,
                                autoplay: false,
                                swipeToSlide: true,
                                slidesToShow: 4,
                                slidesToScroll: 1,
                            },
                        },
                        {
                            breakpoint: 598,
                            settings: {
                                autoplay: false,
                                slidesToShow: 3,
                                slidesToScroll: 1,
                            },
                        },
                        {
                            breakpoint: 461,
                            settings: {
                                autoplay: false,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                centerMode: true,
                                centerPadding: '30px',
                            },
                        },
                    ],
                })
        })
})
